import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import ENV from 'donor-elf-web/config/environment';

export default class OauthQboConnectRoute extends Route {
  @service declare store: Store;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Connecting to Blackbaud';
  }

  async model() {
    await this.store.createRecord('devise-sign-in').save();
    if (ENV.environment === 'development') {
      window.location.href =
        'http://localhost:3000/oauth/blackbaud/request-access';
    } else {
      window.location.href = '/oauth/blackbaud/request-access';
    }
  }
}
